import React, {
  FC, useEffect,
} from 'react';
import { v4 as uuid } from 'uuid';
import {
  RowLeft,
} from '../Styles';
import UserReply from '../components/Reply/UserReply';
import { getFoodifoxDataLazy } from '../../../../../lib/axios/FoodifoxDataAPI';
import { AiTopic } from '../../../../../lib/types/AiTypes';
import RobotReply from '../components/Reply/RobotReply/RobotReply';
import UnitNoInput from '../components/Input/UnitNoInput';
import Q5 from '../Q5';
import Q7 from '../Q7';
import Q9 from '../Q9';
import TempFieldUtils from '../../../../../lib/TempFieldUtils';
import CheckLoading from '../components/Loading/CheckLoading';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import LeftToRight from '../components/Animation/LeftToRight';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';

/**
 * 房间号取餐
 */
const Q3: FC<Props> = ({
  cabId,
  h5Platform,
  addElement,
  setTargetPage,
  deviceCode,
  sessionId,
  enterPhoneNumber,
}) => {
  // 把选项发送给后台
  const [getH5OrderBoxListByUnitNo] = getFoodifoxDataLazy<AiTopic>('/fox3PDAi/getH5OrderBoxListByUnitNo');
  // 检查柜子是否在线
  const [getCabOnline] = getFoodifoxDataLazy<boolean>('/fox3PDAi/cabOnlineStatus?cabId=' + cabId);

  /**
   * 发送选项给后台
   * @param unitNo  输入的门牌号
   */
  const send = (unitNo: string) => {
    const loadingFlowId = uuid();
    addElement(
      <CheckLoading
        flowId={loadingFlowId}
        zhText={'请稍等…正在查询订单…'}
        enText={'Please wait...We are confirming details.'}
        style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.58, getWindowWidth() * 0.55) }}
      />
    );

    // 发送选项给后台
    getH5OrderBoxListByUnitNo({
      param: {
        useCabId: cabId,
        roomNo: unitNo,
      },
      onCompleted({ id, boxNumberList: boxList, boxOfflineCode }) {
        setTimeout(() => {
          if ((boxList || []).length > 0 || (boxOfflineCode || []).length > 0) {
            // loading显示打勾
            TempFieldUtils.aiRetainLoadingIds.push(loadingFlowId);
          }
          else {
            // 隐藏loading
            TempFieldUtils.aiFlowIds.push(loadingFlowId);
          }
        }, 2000);
        setTimeout(() => {
          // 查询到了订单，并且柜子在线
          if ((boxList || []).length > 0 && (boxOfflineCode || []).length === 0) {
            checkOnline(unitNo, boxList || [], boxOfflineCode || []);
          }
          // 查询到了订单，但是柜子离线了
          else if ((boxList || []).length > 0 && (boxOfflineCode || []).length > 0) {
            checkOnline(unitNo, boxList || [], boxOfflineCode || []);
          }
          // 没有查询到订单
          else {
            addElement(
              <Q5
                cabId={cabId}
                h5Platform={h5Platform}
                addElement={addElement}
                setTargetPage={setTargetPage}
                deviceCode={deviceCode}
                sessionId={sessionId}
                roomNo={unitNo}
                enterPhoneNumber={enterPhoneNumber}
              />
            );
          }
        }, 2200);
      },
    });
  };

  const checkOnline = (unitNo: string, boxList: { cabId: number; boxNumber: string }[], boxOfflineCode: { qrCode: string; boxNumber: string }[]) => {
    const loadingFlowId = uuid();
    addElement(
      <CheckLoading
        flowId={loadingFlowId}
        zhText={'请稍等…正在连接至智能柜…'}
        enText={'Please wait...We are connecting with your locker.'}
        style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.55, getWindowWidth() * 0.58) }}
      />
    );

    getCabOnline({
      onCompleted(isOnline) {
        setTimeout(() => {
          // 隐藏loading
          TempFieldUtils.aiFlowIds.push(loadingFlowId);
          if (!isOnline) {
            TempFieldUtils.aiFlowIds.push(...TempFieldUtils.aiRetainLoadingIds);
            TempFieldUtils.aiRetainLoadingIds = [];
          }
        }, 2000);
        setTimeout(() => {
          if (boxList.length > 0 || boxOfflineCode.length > 0) {
            // 柜子在线
            if (isOnline) {
              addElement(
                <Q7
                  boxList={boxList}
                  addElement={addElement}
                  setTargetPage={setTargetPage}
                  cabId={cabId}
                  h5Platform={h5Platform}
                  deviceCode={deviceCode}
                  loadingFlowId={loadingFlowId}
                  sessionId={sessionId}
                  enterPhoneNumber={enterPhoneNumber}
                />
              );
            }
            // 柜子离线了
            else {
              addElement(
                <Q9
                  cabId={cabId}
                  boxList={boxList}
                  boxOfflineCode={boxOfflineCode}
                  addElement={addElement}
                  setTargetPage={setTargetPage}
                  h5Platform={h5Platform}
                  deviceCode={deviceCode}
                  sessionId={sessionId}
                  enterPhoneNumber={enterPhoneNumber}
                />
              );
            }
          }
          else {
            addElement(
              <Q5
                cabId={cabId}
                h5Platform={h5Platform}
                addElement={addElement}
                setTargetPage={setTargetPage}
                deviceCode={deviceCode}
                sessionId={sessionId}
                roomNo={unitNo}
                enterPhoneNumber={enterPhoneNumber}
              />
            );
          }
        }, 2500);
      }
    });
  };

  useEffect(() => {
    // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
    const flowId = uuid();
    const langZh = '请在下方输入您的门牌号';
    const langEn = 'Please enter your apartment/unit number below';
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.65, getWindowWidth() * 0.6) }}
            langZh={langZh}
            langEn={langEn}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q3 - bot: ' + langEn, sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          <RowLeft>
            <UnitNoInput
              flowId={flowId}
              callback={(unitNo) => {
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q3 - user: ' + unitNo, sessionId);
                addElement(
                  <UserReply
                    langZh={unitNo}
                    langEn={unitNo}
                  />
                );
                send(unitNo);
              }}
            />
          </RowLeft>
        </LeftToRight>
      );
    }, 400);
  }, []);

  return (
    <></>
  );
};

export interface Props {
  cabId: number;
  h5Platform: number;
  addElement: (elements: any) => void;
  setTargetPage: (targetPage: string) => void;
  deviceCode: string;
  sessionId: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default Q3;
